import React from "react";
import { useTranslation } from "react-i18next";
import { getSbProductName, getStreamsProductName } from "../../../apiclients/CommonUtils";

function UserSmartboxSettings({ register, setValue, watch , errors, clearErrors }) {
  const { t, i18n } = useTranslation();
  const streamsProductName = getStreamsProductName();
  const sbProductName = getSbProductName();
  return (
    <>
      <div className="general-settings" id="Smartbox">
        {JSON.parse(sessionStorage.getItem("admin_session"))?.sb_productname ?? "SmartBox"}
      </div>
      <div className="ps-0">
        <div className="add-numbermain">
          <div className="tel-numbers">{t("EnSmartbox", {"SB_PRODUCT_NAME" : sbProductName})}</div>
          <div className="phoneselect">
            <label className="switch">
              <input
                className="form-control"
                type="checkbox"
                {...register("smart_box.enable_smart_box")}
                onChange={(e) => {
                    clearErrors("smart_box");
                    setValue("smart_box.enable_smart_box", e.target.checked, {
                      shouldDirty: true,
                    });
                  }
                }
               
              />
              <span className="slider round"></span>
            </label>
          {errors?.smart_box?.message && (
              <p className="text-danger">
                {errors?.smart_box?.message}
              </p>
            )}
          </div>
        </div>
        {watch("smart_box.enable_smart_box") && (
          <div>
            <div className="add-numbermain">
              <div className="tel-numbers">{t("SmartBoxaccountsharing", {"SB_PRODUCT_NAME" : sbProductName})}</div>
              <div className="phoneselect">
                <label className="switch">
                  <input
                    className="form-control"
                    type="checkbox"
                    {...register("smart_box.acc_sharing")}
                  />
                  <span className="slider round"></span>
                </label>
              </div>
            </div>
            <div className="add-numbermain">
              <div className="tel-numbers">{t("AllowSmartBoxLocalSync", {"SB_PRODUCT_NAME" : sbProductName})}</div>
              <div className="phoneselect">
                <label className="switch">
                  <input
                    className="form-control"
                    type="checkbox"
                    {...register("smart_box.local_client")}
                  />
                  <span className="slider round"></span>
                </label>
              </div>
            </div>
            <div className="add-numbermain">
              <div className="tel-numbers">{t("AllowSmartBoxStreamsMob", {"PRODUCT_NAME" : streamsProductName, "SB_PRODUCT_NAME" : sbProductName})}</div>
              <div className="phoneselect">
                <label className="switch">
                  <input
                    className="form-control"
                    type="checkbox"
                    {...register("smart_box.mobile_client")}
                  />
                  <span className="slider round"></span>
                </label>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default UserSmartboxSettings;
